// @ts-ignore
import loadable from '@loadable/component'
import { VFC } from 'react'

const TeacherDashboard = loadable(() => import('./TeacherDashboard'))
export const LoadableTeacherDashboard: VFC = () => <TeacherDashboard />
